import { useForm } from '@tanstack/react-form'
import { useDebounce } from 'commons/hooks/common'
import { FF, Select, TextInput } from 'ui/components'
import { FilterPanel } from 'ui/components/Table'
import { useTemplatesListContext } from '~bank-document-templates/list/context'
import { DocTemplateListPayload } from '~bank-document-templates/types'

import { s } from './style'

export const Filter = () => {
  const { routeApi, data } = useTemplatesListContext()
  const navigate = routeApi.useNavigate()
  const { activeOptions, typeOptions, frequencyOptions, levelOptions, startDateTypeOptions, stateOptions } = data
  const searchParams = routeApi.useSearch()
  const isChanged = routeApi.useLoaderDeps({ select: (s) => s.isChanged })

  const formApi = useForm({
    defaultValues: searchParams as Omit<DocTemplateListPayload, 'page' | 'size' | 'sortDesc'>
  })

  const clear = () => {
    formApi.reset()
    navigate({ search: undefined })
  }

  const updateSearchParams = (newValue: string) =>
    navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, documentName: newValue }) })

  const throttledSearch = useDebounce(updateSearchParams, 300)

  return (
    <FilterPanel isDirty={isChanged} onReset={clear} expanded>
      <s.Columns>
        <s.Column>
          <formApi.Field
            name="documentName"
            listeners={{
              onChange: ({ value }) => {
                throttledSearch(value)
                return undefined
              }
            }}
            children={(field) => (
              <FF field={field} label="Document Name" input={(inputProps) => <TextInput {...inputProps} />} />
            )}
          />
        </s.Column>
        <s.Column>
          <formApi.Field
            name="active"
            listeners={{
              onChange: ({ value }) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, active: value }) })
                return undefined
              }
            }}
            children={(field) => (
              <FF field={field} label="Active" input={(p) => <Select {...p} data={activeOptions} />} />
            )}
          />
        </s.Column>
        <s.Column>
          <formApi.Field
            name="type"
            listeners={{
              onChange: ({ value }) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, type: value }) })
                return undefined
              }
            }}
            children={(field) => (
              <FF field={field} label="Document Type" input={(p) => <Select {...p} data={typeOptions} />} />
            )}
          />
        </s.Column>
        <s.Column>
          <formApi.Field
            name="frequency"
            listeners={{
              onChange: ({ value }) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, frequency: value }) })
                return undefined
              }
            }}
            children={(field) => (
              <FF field={field} label="Frequency" input={(p) => <Select {...p} data={frequencyOptions} />} />
            )}
          />
        </s.Column>
        <s.Column>
          <formApi.Field
            name="level"
            listeners={{
              onChange: ({ value }) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, level: value }) })
                return undefined
              }
            }}
            children={(field) => (
              <FF field={field} label="Level" input={(p) => <Select {...p} data={levelOptions} />} />
            )}
          />
        </s.Column>
        <s.Column>
          <formApi.Field
            name="startDateType"
            listeners={{
              onChange: ({ value }) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, startDateType: value }) })
                return undefined
              }
            }}
            children={(field) => (
              <FF field={field} label="Start Date Type" input={(p) => <Select {...p} data={startDateTypeOptions} />} />
            )}
          />
        </s.Column>
        <s.Column>
          <formApi.Field
            name="state"
            listeners={{
              onChange: ({ value }) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, state: value }) })
                return undefined
              }
            }}
            children={(field) => (
              <FF field={field} label="State" input={(p) => <Select {...p} data={stateOptions} />} />
            )}
          />
        </s.Column>
      </s.Columns>
    </FilterPanel>
  )
}
